import ReactModal from "react-modal";
import {Link, useLocation} from "react-router-dom";
import {common as strings} from "strings";

import Button from "components/Button";
import NavigationTab from "components/NavigationTab";

// import {useHasUpcomingAppointment} from "liberty-core/api/react-query/appointment";
import {signOut, useAuthenticatedUser} from "lib/auth";
import {mainNavLinks, secondaryNavLinks} from "lib/navLinks";
import {KEYS, saveLocalStorage} from "lib/storage";
import {useCurrentPharmacy} from "lib/useCurrentPharmacy";

import styles from "./DrawerMenu.module.css";

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  patientName?: string;
};

export default function DrawerMenu({isOpen, setIsOpen, patientName}: Props) {
  const currentPath = useLocation().pathname;
  const [pharmacy] = useCurrentPharmacy();
  const [authenticatedUser] = useAuthenticatedUser();
  // const hasUpcoming = useHasUpcomingAppointment({enabled: !!authenticatedUser});
  const onNavigationClick = () => {
    setIsOpen(false);
  };

  return (
    <ReactModal
      isOpen={isOpen}
      className={styles.modal}
      overlayClassName={styles.overlay}
      onRequestClose={() => {
        setIsOpen(false);
      }}
    >
      {patientName ? (
        <div className={styles.topRow}>
          <span className={styles.patientName}>{patientName}</span>
          <Button
            labelClassName={styles.signOutButtonLabel}
            className={styles.signOutButton}
            variant="minimal"
            to={authenticatedUser ? "/" : "/login"}
            onClick={() => {
              setIsOpen(false);
              if (authenticatedUser)
                signOut().then(() => saveLocalStorage(KEYS.email, undefined));
            }}
          >
            {authenticatedUser ? strings.signOut : strings.login}
          </Button>
        </div>
      ) : null}
      <div className={styles.navigationBar}>
        {mainNavLinks(pharmacy?.appointmentsEnabled ?? false).map((navLink) => {
          return (
            <NavigationTab
              key={navLink.label}
              className={styles.navTab}
              label={navLink.label}
              to={navLink.to}
              icon={navLink.icon(
                currentPath.startsWith(navLink.to),
                // hasUpcoming,
              )}
              selected={currentPath.startsWith(navLink.to)}
              onClick={onNavigationClick}
              disabled={!pharmacy || !pharmacy.name}
            />
          );
        })}
      </div>
      {secondaryNavLinks.length > 0 ? (
        <hr className={styles.lineDivider} />
      ) : null}
      {secondaryNavLinks.map((navLink, index) => {
        return (
          <Link
            key={index}
            to={navLink.to}
            className={styles.secondaryLink}
            onClick={() => {
              setIsOpen(false);
            }}
          >
            {navLink.label}
          </Link>
        );
      })}
      {patientName ? null : <div className={styles.rx365}>{strings.rx365}</div>}
    </ReactModal>
  );
}
